export interface AdminNoticeEndpointsProps {
  get_admin_notices_list: (
    page: number,
    size: number,
    keyword?: string
  ) => string; // 공지사항 목록 조회
  get_admin_notice_detail: (noticeId: string) => string; // 공지사항 상세 조회
  create_admin_notice: () => string; // 공지사항 등록
  update_admin_notice: (noticeId: string) => string; // 공지사항 수정
  delete_admin_notice: (noticeId: string) => string; // 공지사항 삭제
}

export const AdminNoticeEndpoints: AdminNoticeEndpointsProps = {
  get_admin_notices_list: (page, size, keyword) => {
    let url = `api/admin/notices?page=${page}&size=${size}`;
    if (keyword) {
      url += `&keyword=${encodeURIComponent(keyword)}`;
    }
    return url;
  },
  get_admin_notice_detail: (noticeId) => `api/admin/notices/${noticeId}`, // 공지사항 상세 조회
  create_admin_notice: () => `api/admin/notices`, // 공지사항 등록
  update_admin_notice: (noticeId) => `api/admin/notices/${noticeId}`, // 공지사항 수정
  delete_admin_notice: (noticeId) => `api/admin/notices/${noticeId}`, // 공지사항 삭제
};

export default AdminNoticeEndpoints;
